<template>
    <div class="ui error message">
        <i class="close icon"></i>
        <div class="header">
            Por favor verifique la siguiente información
        </div>
        <ul class="list">
            <li v-for="(value, key) in data.errors" v-html="getHtml(key, value[0])"></li>
        </ul>
    </div>
</template>
<script>
  export default {
    data () {
      return {}
    },
    props: ['data'],
    mounted () {
      jQuery(this.$el).find('.close')
        .on('click', function (e) {
          $(e.target)
            .closest('.message')
            .transition('fade')
        })
    },
    methods: {
      getHtml (key, value) {
        return (key.replace('_id', '')) + ':' + value
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/error/Error.vue